/// <amd-module name="Search/Wiki/Flux/ActionsHub" />
import * as BaseActionsHub from "Search/Shared/Base/ActionsHub2";
import { WikiSearchRequest, WikiSearchResponse, WikiResult } from 'Search/WebApi/Contracts/Search.Shared';

export class ActionsHub extends BaseActionsHub.ActionsHub<WikiSearchRequest, WikiSearchResponse, WikiResult> { }
